export default __webpack_public_path__ + "static/media/1.123b1dc1.png";